<template lang="pug">
  v-card-text
    validation-provider(
      rules="required"
      vid="task.test1"
      v-slot="{ errors, valid }"
    )
      v-radio-group(
        v-model="answer"
        @change="emitAnswer"
        :error-messages="errors"
      )
        v-radio(v-for="a in taskUnit.possible_answers" :key="a.id" :value="a.id" :label="a.name")
</template>

<script>
export default {
  name: 'TypeOneOfMany',
  props: {
    taskUnit: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    answer: null,
  }),
  methods: {
    emitAnswer() {
      this.$emit('answer', {
        fieldName: 'possible_answer_id',
        answer: this.answer,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
